module.exports = __webpack_public_path__ + "img/product-shot_03.1c21ff26.jpg";